export default __webpack_public_path__ + "static/media/press-19.d1f799b3.jpg";